import type { ModalSDK } from '@fiverr-private/jtbd_sdk';
import ModalComponent from './DownloadAppModal';

export const DownloadAppModalImpl: ModalSDK = {
    ModalComponent,
};
